import { BillingDetailsComponent } from './lib/orc-billing-details/billing-details.component';
export { BillingInfoNavComponent } from './lib/ui-billing-info-nav/billing-info-nav.component';

export default BillingDetailsComponent;
